import React, { useState } from "react";
import Globalcontext from "./Globalcontext";

const Globalstates = (props) => {

    const [tempunanswer, settempunanswer] = useState();
    const [examtype, setexamtype] = useState();
    const [cqueno, setcqueno] = useState();
    const [status, setStatus] = useState();
    const [minutes, setMinutes] = useState(29); //29
    const [seconds, setSeconds] = useState(59); //59
    const [elminutes, setElminutes] = useState();
    const [elseconds, setElseconds] = useState();
    const [elmilli, setElmilli] = useState();
    const [index, setIndex] = useState(0);
    const [correct, setCorrect] = useState(0);
    const [anasweredtemp, setAnasweredtemp] = useState(0);
    const [estiscore, setEstiscore] = useState();
    const [solutionflag, setSolutionflag] = useState("false");
    const [testname, setTestname] = useState();
    const [mainresult, setMainresult] = useState([]);

    const [q1array, setq1array] = useState({});
    const [q2array, setq2array] = useState({});
    const [q3array, setq3array] = useState({});
    const [q4array, setq4array] = useState({});
    const [q5array, setq5array] = useState({});
    const [q6array, setq6array] = useState({});
    const [q7array, setq7array] = useState({});
    const [q8array, setq8array] = useState({});
    const [q9array, setq9array] = useState({});
    const [q10array, setq10array] = useState({});
    const [q11array, setq11array] = useState({});
    const [q12array, setq12array] = useState({});
    const [q13array, setq13array] = useState({});
    const [q14array, setq14array] = useState({});
    const [q15array, setq15array] = useState({});
    const [q16array, setq16array] = useState({});
    const [q17array, setq17array] = useState({});
    const [q18array, setq18array] = useState({});
    const [q19array, setq19array] = useState({});
    const [q20array, setq20array] = useState({});

    const [q1, setq1] = useState();
    const [q2, setq2] = useState();
    const [q3, setq3] = useState();
    const [q4, setq4] = useState();
    const [q5, setq5] = useState();
    const [q6, setq6] = useState();
    const [q7, setq7] = useState();
    const [q8, setq8] = useState();
    const [q9, setq9] = useState();
    const [q10, setq10] = useState();
    const [q11, setq11] = useState();
    const [q12, setq12] = useState();
    const [q13, setq13] = useState();
    const [q14, setq14] = useState();
    const [q15, setq15] = useState();
    const [q16, setq16] = useState();
    const [q17, setq17] = useState();
    const [q18, setq18] = useState();
    const [q19, setq19] = useState();
    const [q20, setq20] = useState();


    const calccolor = (index) => {

        let tempresult = "";
        
        if (examtype === "Main Test") {
            
            tempresult = JSON.parse(localStorage.getItem("glresult"));
            if(tempresult)
            {
                if (index === 1) {
                    if (tempresult[0].optiona) {
                        return 'numberCirclesolved';
                    }
                    else {
                        return 'numberCircle';
                    }
                }
                if (index === 2) {
                    if (tempresult[1].optiona) {
                        return 'numberCirclesolved';
                    }
                    else {
                        return 'numberCircle';
                    }
                }
                if (index === 3) {
                    if (tempresult[2].optiona) {
                        return 'numberCirclesolved';
                    }
                    else {
                        return 'numberCircle';
                    }
                }
                if (index === 4) {
                    if (tempresult[3].optiona) {
                        return 'numberCirclesolved';
                    }
                    else {
                        return 'numberCircle';
                    }
                }
                if (index === 5) {
                    if (tempresult[4].optiona) {
                        return 'numberCirclesolved';
                    }
                    else {
                        return 'numberCircle';
                    }
                }
                if (index === 6) {
                    if (tempresult[5].optiona) {
                        return 'numberCirclesolved';
                    }
                    else {
                        return 'numberCircle';
                    }
                }
                if (index === 7) {
                    if (tempresult[6].optiona) {
                        return 'numberCirclesolved';
                    }
                    else {
                        return 'numberCircle';
                    }
                }
                if (index === 8) {
                    if (tempresult[7].optiona) {
                        return 'numberCirclesolved';
                    }
                    else {
                        return 'numberCircle';
                    }
                }
                if (index === 9) {
                    if (tempresult[8].optiona) {
                        return 'numberCirclesolved';
                    }
                    else {
                        return 'numberCircle';
                    }
                }
                if (index === 10) {
                    if (tempresult[9].optiona) {
                        return 'numberCirclesolved';
                    }
                    else {
                        return 'numberCircle';
                    }
                }
                if (index === 11) {
        
                    if (tempresult[10].optiona) {
                        return 'numberCirclesolved';
                    }
                    else {
                        return 'numberCircle';
                    }
                }
                if (index === 12) {
                    if (tempresult[11].optiona) {
                        return 'numberCirclesolved';
                    }
                    else {
                        return 'numberCircle';
                    }
                }
                if (index === 13) {
                    if (tempresult[12].optiona) {
                        return 'numberCirclesolved';
                    }
                    else {
                        return 'numberCircle';
                    }
                }
                if (index === 14) {
                    if (tempresult[13].optiona) {
                        return 'numberCirclesolved';
                    }
                    else {
                        return 'numberCircle';
                    }
                }
                if (index === 15) {
                    if (tempresult[14].optiona) {
                        return 'numberCirclesolved';
                    }
                    else {
                        return 'numberCircle';
                    }
                }
                if (index === 16) {
                    if (tempresult[15].optiona) {
                        return 'numberCirclesolved';
                    }
                    else {
                        return 'numberCircle';
                    }
                }
                if (index === 17) {
                    if (tempresult[16].optiona) {
                        return 'numberCirclesolved';
                    }
                    else {
                        return 'numberCircle';
                    }
                }
                if (index === 18) {
                    if (tempresult[17].optiona) {
                        return 'numberCirclesolved';
                    }
                    else {
                        return 'numberCircle';
                    }
                }
                if (index === 19) {
                    if (tempresult[18].optiona) {
                        return 'numberCirclesolved';
                    }
                    else {
                        return 'numberCircle';
                    }
                }
                if (index === 20) {
                    if (tempresult[19].optiona) {
                        return 'numberCirclesolved';
                    }
                    else {
                        return 'numberCircle';
                    }
                }
            }
            else{
                if (index === 1) {
                    if (q1array.option) {
                        return 'numberCirclesolved';
                    }
                    else {
                        return 'numberCircle';
                    }
                }
                if (index === 2) {
                    if (q2array.option) {
                        return 'numberCirclesolved';
                    }
                    else {
                        return 'numberCircle';
                    }
                }
                if (index === 3) {
                    if (q3array.option) {
                        return 'numberCirclesolved';
                    }
                    else {
                        return 'numberCircle';
                    }
                }
                if (index === 4) {
                    if (q4array.option) {
                        return 'numberCirclesolved';
                    }
                    else {
                        return 'numberCircle';
                    }
                }
                if (index === 5) {
                    if (q5array.option) {
                        return 'numberCirclesolved';
                    }
                    else {
                        return 'numberCircle';
                    }
                }
                if (index === 6) {
                    if (q6array.option) {
                        return 'numberCirclesolved';
                    }
                    else {
                        return 'numberCircle';
                    }
                }
                if (index === 7) {
                    if (q7array.option) {
                        return 'numberCirclesolved';
                    }
                    else {
                        return 'numberCircle';
                    }
                }
                if (index === 8) {
                    if (q8array.option) {
                        return 'numberCirclesolved';
                    }
                    else {
                        return 'numberCircle';
                    }
                }
                if (index === 9) {
                    if (q9array.option) {
                        return 'numberCirclesolved';
                    }
                    else {
                        return 'numberCircle';
                    }
                }
                if (index === 10) {
                    if (q10array.option) {
                        return 'numberCirclesolved';
                    }
                    else {
                        return 'numberCircle';
                    }
                }
                if (index === 11) {
        
                    if (q11array.option) {
                        return 'numberCirclesolved';
                    }
                    else {
                        return 'numberCircle';
                    }
                }
                if (index === 12) {
                    if (q12array.option) {
                        return 'numberCirclesolved';
                    }
                    else {
                        return 'numberCircle';
                    }
                }
                if (index === 13) {
                    if (q13array.option) {
                        return 'numberCirclesolved';
                    }
                    else {
                        return 'numberCircle';
                    }
                }
                if (index === 14) {
                    if (q14array.option) {
                        return 'numberCirclesolved';
                    }
                    else {
                        return 'numberCircle';
                    }
                }
                if (index === 15) {
                    if (q15array.option) {
                        return 'numberCirclesolved';
                    }
                    else {
                        return 'numberCircle';
                    }
                }
                if (index === 16) {
                    if (q16array.option) {
                        return 'numberCirclesolved';
                    }
                    else {
                        return 'numberCircle';
                    }
                }
                if (index === 17) {
                    if (q17array.option) {
                        return 'numberCirclesolved';
                    }
                    else {
                        return 'numberCircle';
                    }
                }
                if (index === 18) {
                    if (q18array.option) {
                        return 'numberCirclesolved';
                    }
                    else {
                        return 'numberCircle';
                    }
                }
                if (index === 19) {
                    if (q19array.option) {
                        return 'numberCirclesolved';
                    }
                    else {
                        return 'numberCircle';
                    }
                }
                if (index === 20) {
                    if (q20array.option) {
                        return 'numberCirclesolved';
                    }
                    else {
                        return 'numberCircle';
                    }
                }
            }

        }
        else {
         
            if (index === 1) {
                if (q1array.option) {
                    return 'numberCirclesolved';
                }
                else {
                    return 'numberCircle';
                }
            }
            if (index === 2) {
                if (q2array.option) {
                    return 'numberCirclesolved';
                }
                else {
                    return 'numberCircle';
                }
            }
            if (index === 3) {
                if (q3array.option) {
                    return 'numberCirclesolved';
                }
                else {
                    return 'numberCircle';
                }
            }
            if (index === 4) {
                if (q4array.option) {
                    return 'numberCirclesolved';
                }
                else {
                    return 'numberCircle';
                }
            }
            if (index === 5) {
                if (q5array.option) {
                    return 'numberCirclesolved';
                }
                else {
                    return 'numberCircle';
                }
            }
            if (index === 6) {
                if (q6array.option) {
                    return 'numberCirclesolved';
                }
                else {
                    return 'numberCircle';
                }
            }
            if (index === 7) {
                if (q7array.option) {
                    return 'numberCirclesolved';
                }
                else {
                    return 'numberCircle';
                }
            }
            if (index === 8) {
                if (q8array.option) {
                    return 'numberCirclesolved';
                }
                else {
                    return 'numberCircle';
                }
            }
            if (index === 9) {
                if (q9array.option) {
                    return 'numberCirclesolved';
                }
                else {
                    return 'numberCircle';
                }
            }
            if (index === 10) {
                if (q10array.option) {
                    return 'numberCirclesolved';
                }
                else {
                    return 'numberCircle';
                }
            }
            if (index === 11) {
    
                if (q11array.option) {
                    return 'numberCirclesolved';
                }
                else {
                    return 'numberCircle';
                }
            }
            if (index === 12) {
                if (q12array.option) {
                    return 'numberCirclesolved';
                }
                else {
                    return 'numberCircle';
                }
            }
            if (index === 13) {
                if (q13array.option) {
                    return 'numberCirclesolved';
                }
                else {
                    return 'numberCircle';
                }
            }
            if (index === 14) {
                if (q14array.option) {
                    return 'numberCirclesolved';
                }
                else {
                    return 'numberCircle';
                }
            }
            if (index === 15) {
                if (q15array.option) {
                    return 'numberCirclesolved';
                }
                else {
                    return 'numberCircle';
                }
            }
            if (index === 16) {
                if (q16array.option) {
                    return 'numberCirclesolved';
                }
                else {
                    return 'numberCircle';
                }
            }
            if (index === 17) {
                if (q17array.option) {
                    return 'numberCirclesolved';
                }
                else {
                    return 'numberCircle';
                }
            }
            if (index === 18) {
                if (q18array.option) {
                    return 'numberCirclesolved';
                }
                else {
                    return 'numberCircle';
                }
            }
            if (index === 19) {
                if (q19array.option) {
                    return 'numberCirclesolved';
                }
                else {
                    return 'numberCircle';
                }
            }
            if (index === 20) {
                if (q20array.option) {
                    return 'numberCirclesolved';
                }
                else {
                    return 'numberCircle';
                }
            }
        }


    }

   
    const calcstatus = (index) => {

        if (index === 1) {
            if (q1array["option"]) {
                return 'Solved';
            }
            else {
                return 'Unsolved';
            }
        }
        if (index === 2) {
            if (q2array["option"]) {
                return 'Solved';
            }
            else {
                return 'Unsolved';
            }
        }
        if (index === 3) {
            if (q3array["option"]) {
                return 'Solved';
            }
            else {
                return 'Unsolved';
            }
        }
        if (index === 4) {
            if (q4array["option"]) {
                return 'Solved';
            }
            else {
                return 'Unsolved';
            }
        }
        if (index === 5) {
            if (q5array["option"]) {
                return 'Solved';
            }
            else {
                return 'Unsolved';
            }
        }
        if (index === 6) {
            if (q6array["option"]) {
                return 'Solved';
            }
            else {
                return 'Unsolved';
            }
        }
        if (index === 7) {
            if (q7array["option"]) {
                return 'Solved';
            }
            else {
                return 'Unsolved';
            }
        }
        if (index === 8) {
            if (q8array["option"]) {
                return 'Solved';
            }
            else {
                return 'Unsolved';
            }
        }
        if (index === 9) {
            if (q9array["option"]) {
                return 'Solved';
            }
            else {
                return 'Unsolved';
            }
        }
        if (index === 10) {
            if (q10array["option"]) {
                return 'Solved';
            }
            else {
                return 'Unsolved';
            }
        }
        if (index === 11) {

            if (q11array["option"]) {
                return 'Solved';
            }
            else {
                return 'Unsolved';
            }
        }
        if (index === 12) {
            if (q12array["option"]) {
                return 'Solved';
            }
            else {
                return 'Unsolved';
            }
        }
        if (index === 13) {
            if (q13array["option"]) {
                return 'Solved';
            }
            else {
                return 'Unsolved';
            }
        }
        if (index === 14) {
            if (q14array["option"]) {
                return 'Solved';
            }
            else {
                return 'Unsolved';
            }
        }
        if (index === 15) {
            if (q15array["option"]) {
                return 'Solved';
            }
            else {
                return 'Unsolved';
            }
        }
        if (index === 16) {
            if (q16array["option"]) {
                return 'Solved';
            }
            else {
                return 'Unsolved';
            }
        }
        if (index === 17) {
            if (q17array["option"]) {
                return 'Solved';
            }
            else {
                return 'Unsolved';
            }
        }
        if (index === 18) {
            if (q18array["option"]) {
                return 'Solved';
            }
            else {
                return 'Unsolved';
            }
        }
        if (index === 19) {
            if (q19array["option"]) {
                return 'Solved';
            }
            else {
                return 'Unsolved';
            }
        }
        if (index === 20) {
            if (q20array["option"]) {
                return 'Solved';
            }
            else {
                return 'Unsolved';
            }
        }
    }
    const calcsolved = () => {
        let i = 0;

        if (q1array["option"]) {
            i++;
        }
        if (q2array["option"]) {
            i++;
        }
        if (q3array["option"]) {
            i++;
        }
        if (q4array["option"]) {
            i++;
        }
        if (q5array["option"]) {
            i++;
        }
        if (q6array["option"]) {
            i++;
        }
        if (q7array["option"]) {
            i++;
        }
        if (q8array["option"]) {
            i++;
        }
        if (q9array["option"]) {
            i++;
        }
        if (q10array["option"]) {
            i++;
        }
        if (q11array["option"]) {
            i++;
        }
        if (q12array["option"]) {
            i++;
        }
        if (q13array["option"]) {
            i++;
        }
        if (q14array["option"]) {
            i++;
        }
        if (q15array["option"]) {
            i++;
        }
        if (q16array["option"]) {
            i++;
        }
        if (q17array["option"]) {
            i++;
        }
        if (q18array["option"]) {
            i++;
        }
        if (q19array["option"]) {
            i++;
        }
        if (q20array["option"]) {
            i++;
        }

        return i;
    }

    const [sname, setSname] = useState();
    const [grade, setGrade] = useState();
    const [school, setSchool] = useState();
    const [coordinator, setCoordinator] = useState();
    const [dob, setDob] = useState();
    const [gender, setGender] = useState();
    const [studentstatus, setStudentstatus] = useState();
    const [language, setLanguage] = useState();

    return (
        <Globalcontext.Provider value={{ q1array, setq1array, q2array, setq2array, q3array, setq3array, q4array, setq4array, q5array, setq5array, q6array, setq6array, q7array, setq7array, q8array, setq8array, q9array, setq9array, q10array, setq10array, q11array, setq11array, q12array, setq12array, q13array, setq13array, q14array, setq14array, q15array, setq15array, q16array, setq16array, q17array, setq17array, q18array, setq18array, q19array, setq19array, q20array, setq20array, q1, setq1, q2, setq2, q3, setq3, q4, setq4, q5, setq5, q6, setq6, q7, setq7, q8, setq8, q9, setq9, q10, setq10, q11, setq11, q12, setq12, q13, setq13, q14, setq14, q15, setq15, q16, setq16, q17, setq17, q18, setq18, q19, setq19, q20, setq20, status, setStatus, minutes, setMinutes, seconds, setSeconds, index, setIndex, correct, setCorrect, anasweredtemp, setAnasweredtemp, estiscore, setEstiscore, elminutes, setElminutes, elseconds, setElseconds, elmilli, setElmilli, solutionflag, setSolutionflag, sname, setSname, grade, setGrade, school, setSchool, coordinator, setCoordinator, dob, setDob, gender, setGender, studentstatus, setStudentstatus, language, setLanguage, mainresult, setMainresult, calcsolved, calcstatus, calccolor, tempunanswer, settempunanswer,examtype,setexamtype,cqueno,setcqueno,testname,setTestname}}>

            {props.children}

        </Globalcontext.Provider>
    )
}

export default Globalstates;